import { Star } from "./Star";

type Props = {
  rating: number;
  totales: number;
  fontStar: number;
  fontNumber: number;
};

export const StarRating = ({
  rating,
  totales,
  fontStar,
  fontNumber,
}: Props): JSX.Element => {
  const stars = [];
  for (let i = 0; i < totales; i++) {
    stars.push(
      <Star key={i} filled={i < rating} fontStar={String(fontStar)} />
    );
  }

  return (
    <span>
      {stars} <span style={{ fontSize: fontNumber }}>0{rating}</span>
    </span>
  );
};
